document.addEventListener("wpcf7mailsent", function (event) {
	const form = event.target;
	const output = form.querySelector(".wpcf7-response-output");

	if (!output) return;

	// Delay to ensure CF7 has rendered the success message
	setTimeout(() => {
		if (!form.querySelector(".extra-html")) {
			// avoid duplicates
			output.insertAdjacentHTML(
				"beforeend",
				`
                <div class="extra-html">
                    Meanwhile, if you would like to explore more, you can view our prospectus here.
                </div>
                <a href="/prospectus" class="cta -outline -primary" aria-label="Prospectus">Prospectus</a>
            `
			);
		}
	}, 50); // 50ms usually enough; increase to 100ms if needed
});
